import React from 'react';
import { Link } from 'react-router-dom'


const Footer = () => {
    return (
        <div style={{
            padding: '16px 24px',
            borderTop: '1px solid #E2E8F0',
            background: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginTop: 'auto'
        }}>
            <span style={{
                fontSize: '12px',
                color: '#94A3B8',
                fontWeight: '400'
            }}>
                &copy; {new Date().getFullYear()} Outbound Switch
            </span>
            <Link to={"#"} style={{
                fontSize: '12px',
                color: '#94A3B8',
                textDecoration: 'none',
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                transition: 'color 150ms ease'
            }}>
                <i className="icon-question7" style={{fontSize: '13px'}}></i>
                Help
            </Link>
        </div>
    );
};

export default Footer;
